// extracted by mini-css-extract-plugin
export default {"decoration":"DecorationImage_decoration__mJbhp"};